import { CrossChannelContext } from "../CrossChannel";
import { DEFAULT_SPARKCHARTS_MAP } from "../../SingleChannel/MetricsTableConfig/EditPagePresetModal";
import { METRIC_OPTIONS } from "../crossChannelConstants";
import { Metric, MetricTotalsByDate } from "@blisspointmedia/bpm-types/dist/CrossChannel";
import CompareMetrics from "../Components/CompareMetrics";
import React, { useContext } from "react";
import SparkChart from "../../Components/SparkChart/SparkChart";

interface OverviewProps {
  data: MetricTotalsByDate[];
  otherData: MetricTotalsByDate[];
  defaultCompareMetrics: Metric[] | undefined;
  defaultCompareMetricsIncludeOtherDates;
  defaultSparkCharts?: Metric[];
}

export const DEFAULT_METRICS = DEFAULT_SPARKCHARTS_MAP["cross-channel"];

const Overview: React.FC<OverviewProps> = ({
  data,
  otherData,
  defaultCompareMetrics,
  defaultCompareMetricsIncludeOtherDates = false,
  defaultSparkCharts = DEFAULT_METRICS,
}) => {
  const { kpi, dataInfo } = useContext(CrossChannelContext);

  return (
    <div className="ccOverview">
      <div className="ccTopSection">
        <div className="ccTopSectionLeftSide">
          <div className="ccSparkCharts">
            {defaultSparkCharts.slice(0, DEFAULT_METRICS.length).map((metric, index) => (
              <SparkChart
                pngLabel={`KPI: ${kpi}`}
                pngFileIdentifiers={["CrossChannel"]}
                data={data}
                otherData={otherData}
                defaultMetric={metric}
                key={metric}
                metricOptions={METRIC_OPTIONS}
                dataInfo={dataInfo}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="ccRow">
        <div className="ccAgencyNews">
          <a
            href="https://info.tinuiti.com/Tinuiti-Measuring-Brand-Equitys-Impact-on-Revenue"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="ccAgencyNewsImage"
              src={"https://cdn.blisspointmedia.com/agencies/tinuiti/brand_equity_whitepaper.png"}
              alt="Agency News"
              width={500}
              height={500}
            />
          </a>
        </div>
        <div className="ccMetricComparisonChart">
          <CompareMetrics
            pngDownloadLabel={`KPI: ${kpi}`}
            pngFileIdentifiers={["CrossChannel"]}
            data={data}
            otherData={otherData}
            defaultMetrics={defaultCompareMetrics}
            defaultIncludeOtherDates={defaultCompareMetricsIncludeOtherDates}
            includeFooter={true}
            metricOptions={METRIC_OPTIONS}
          />
        </div>
      </div>
    </div>
  );
};

export default Overview;
